import type { TextFieldProps } from './TextField.types'
import * as S from './TextField.styles'
import useGuideText from '../../hooks/useGuideText'

const TextField = ({
  variant = 'standard',
  color = 'primary',
  fullWidth = true,
  label,
  hideLabel,
  helperText,
  hideHelperText,
  ...props
}: TextFieldProps) => {
  const { label: computedLabel, helperText: computedHelperText } = useGuideText({
    label,
    hideLabel,
    helperText,
    hideHelperText,
  })

  return (
    <S.TextField
      variant={variant}
      fullWidth={fullWidth}
      color={color}
      label={computedLabel}
      helperText={computedHelperText}
      {...props}
    />
  )
}

export default TextField
